import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import { WarehouseLocalizationDetailsFormComponent } from '../../components/warehouse-localization-details-form/warehouse-localization-details-form.component';
import { WarehouseLocalizationDetailsForm } from '../../models/warehouse-localization-details-form';
import { WarehouseLocalizationDataSourceService } from '../../services/warehouse-localization-data-source.service';
import { once } from '@web/utils';

@Component({
  selector: 'app-warehouse-localization-create',
  imports: [WarehouseLocalizationDetailsFormComponent],
  templateUrl: './warehouse-localization-create.component.html',
  styleUrl: './warehouse-localization-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseLocalizationCreateComponent {
  /* prettier-ignore */
  private readonly warehouseLocalizationDataSource = inject(WarehouseLocalizationDataSourceService);

  public readonly submitSuccessEvent = output();

  protected handleSubmitClickEvent(
    data: WarehouseLocalizationDetailsForm,
  ): void {
    this.warehouseLocalizationDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }
}
